import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const HubAuthContext = createContext(null);

export function HubAuthProvider({ children }) {
  const [hubUser, setHubUser] = useState(null);
  const [hubLoading, setHubLoading] = useState(true);

  const checkHubAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/hub/auth/me");
      setHubUser(data);
    } catch {
      setHubUser(false);
    } finally {
      setHubLoading(false);
    }
  }, []);

  useEffect(() => { checkHubAuth(); }, [checkHubAuth]);

  const hubLogin = async (username, password) => {
    const { data } = await api.post("/hub/auth/login", { username, password });
    setHubUser(data);
    return data;
  };

  const hubLogout = async () => {
    try { await api.post("/hub/auth/logout"); } catch {}
    setHubUser(false);
  };

  return (
    <HubAuthContext.Provider value={{ hubUser, hubLoading, hubLogin, hubLogout }}>
      {children}
    </HubAuthContext.Provider>
  );
}

export const useHubAuth = () => useContext(HubAuthContext);
